import { Col, Row } from 'antd';
import React from 'react';

import LogoPXWhite from 'styles/images/DX_LOGO.svg';

const footerStyleTop: React.CSSProperties = {
    backgroundColor: 'rgba(4, 6, 8, .85)',
    width: '100%',
    height: '150px',
    textAlign: 'center',
    color: 'white',
    marginTop: 'auto'
};

const footerStyleBot: React.CSSProperties = {
    width: '100%',
    height: '50px',
    textAlign: 'center'
};

const Footer = () => {
    return (
        <>
            <div style={footerStyleTop}>
                <Row
                    style={{
                        paddingTop: '50px'
                    }}
                >
                    <Col span={8}>
                        <img src={LogoPXWhite} className="main-logo-bottom" />
                    </Col>
                    {/* <Col span={4}>Dokumenty</Col>
                    <Col span={4}>Technické informace</Col>
                <Col span={4}>Odkazy</Col>*/}
                </Row>
            </div>
            <div style={footerStyleBot}>
                <Row
                    style={{
                        marginTop: '20px'
                    }}
                >
                    <Col span={12}>Obsah stránek: 2024 Centrální depozitář cenných papírů, a.s. </Col>
                    <Col span={12}>
                        <a
                            href={`${
                                window.location.href.includes('test') ? 'https://test.cdcp.cz' : 'https://www.cdcp.cz'
                            }/pravni-informace/`}
                        >
                            Právní informace
                        </a>
                        {' | '}
                        <a
                            href={`${
                                window.location.href.includes('test') ? 'https://test.cdcp.cz' : 'https://www.cdcp.cz'
                            }/ochrana-osobnich-udaju-a-nastaveni-cookies/`}
                        >
                            Ochrana osobních údajů a nastavení cookies
                        </a>
                        {' | '}
                        <a
                            href={`${
                                window.location.href.includes('test') ? 'https://test.cdcp.cz' : 'https://www.cdcp.cz'
                            }/o-nas/kontakty/`}
                        >
                            Kontakty
                        </a>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default Footer;
